(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1257],{

/***/ 71257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ EngageCustomers_EngageCustomers; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/TwilioEngage/components/EngageCustomers/assets/EngageCustomers@2x.png
var EngageCustomers_2x = __webpack_require__(60854);
var EngageCustomers_2x_default = /*#__PURE__*/__webpack_require__.n(EngageCustomers_2x);
// EXTERNAL MODULE: ./src/views/TwilioEngage/components/EngageCustomers/assets/EngageCustomers.webp
var EngageCustomers = __webpack_require__(42494);
var EngageCustomers_default = /*#__PURE__*/__webpack_require__.n(EngageCustomers);
// EXTERNAL MODULE: ./src/views/TwilioEngage/components/EngageCustomers/assets/EngageCustomers@2x.webp
var assets_EngageCustomers_2x = __webpack_require__(71771);
var assets_EngageCustomers_2x_default = /*#__PURE__*/__webpack_require__.n(assets_EngageCustomers_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/TwilioEngage/components/EngageCustomers/EngageCustomersImage.tsx







var SIZES = "557px, 1114px";

var EngageCustomersImage = function EngageCustomersImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat((EngageCustomers_default()), " 557w, ").concat((assets_EngageCustomers_2x_default()), " 1114w"),
        sizes: SIZES
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
        src: (EngageCustomers_2x_default()),
        sizes: SIZES,
        alt: "Build Complete View",
        width: "557",
        height: "462",
        loading: "lazy"
      })]
    })
  });
};

var ImageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eymil3d0"
} : 0)("display:flex;flex-direction:column;justify-content:center;align-items:center;padding:0px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
}, "{height:100%;}" + ( true ? "" : 0));

/* harmony default export */ var EngageCustomers_EngageCustomersImage = (EngageCustomersImage);
;// CONCATENATED MODULE: ./src/views/TwilioEngage/components/EngageCustomers/EngageCustomers.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var copy = {
  heading: "Engage customers on trusted native channels",
  description: "Deliver unified, personalized experiences on native channels, like email, WhatsApp, and SMS, on a single, consolidated multichannel marketing solution."
};
var EngageCustomers_link = {
  text: "Explore WhatsApp",
  url: "/product/twilio-engage/whatsapp/"
};
var features = [{
  heading: "Craft data-driven email campaigns that drive results",
  description: "Engage your customers with precise messaging and targeting with multi-step lifecycle campaigns or one\u2013time email blasts."
}, {
  heading: "Consolidate your tech stack to drive efficiency at scale",
  description: "Reduce expenses by centralizing your multichannel marketing while scaling your communications with native email, SMS, and WhatsApp all in one solution."
}, {
  heading: "Mobile marketing campaigns for each stage of your customer journey",
  description: "Distribute timely and relevant marketing messages and offers to drive leads, sales, and loyalty across mobile including SMS, MMS and WhatsApp."
}];

var BuildCompleteView = function BuildCompleteView() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionWrapper, {
    variant: "2Col",
    reverse: true,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionCopy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          children: copy.description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrackWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          gap: "small",
          children: features.map(function (feature, index) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* default */.ZP, {
              alignment: "left",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                  children: feature.heading
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                  children: feature.description
                })]
              })
            }, index);
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
        href: (0,getAbsoluteUrl/* default */.Z)(EngageCustomers_link.url, pageConfig),
        children: EngageCustomers_link.text
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EngageCustomers_EngageCustomersImage, {})
    })]
  });
};

var SectionWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e186at2m2"
} : 0)( true ? {
  name: "ajfln6",
  styles: "overflow-x:visible"
} : 0);

var StyledSectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e186at2m1"
} : 0)("direction:ltr;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{justify-self:end;max-width:440px;}" + ( true ? "" : 0));

var ColumnTrackWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e186at2m0"
} : 0)( true ? {
  name: "1lw3ul3",
  styles: "margin-top:40px"
} : 0);

/* harmony default export */ var EngageCustomers_EngageCustomers = (BuildCompleteView);
;// CONCATENATED MODULE: ./src/views/TwilioEngage/components/EngageCustomers/index.ts


/***/ }),

/***/ 33514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Dx; },
/* harmony export */   "Hq": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Hq; },
/* harmony export */   "ZP": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Ob; },
/* harmony export */   "h4": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.h4; },
/* harmony export */   "uT": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "xv": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.xv; }
/* harmony export */ });
/* harmony import */ var _FeatureBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13379);

_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .FeatureBox.displayName */ .Ob.displayName = "FeatureBoxBase";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Body.displayName */ .uT.displayName = "FeatureBox.Body";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Header.displayName */ .h4.displayName = "FeatureBox.Header";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Text.displayName */ .xv.displayName = "FeatureBox.Text";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Title.displayName */ .Dx.displayName = "FeatureBox.Title";


/***/ }),

/***/ 60854:
/***/ (function(module) {

module.exports = "/_next/static/images/EngageCustomers@2x-7a0f8ead2b390420e5b9fd779807426b.png";

/***/ }),

/***/ 42494:
/***/ (function(module) {

module.exports = "/_next/static/images/EngageCustomers-2cbefc77b83e408c12aac36db0ab8cc9.webp";

/***/ }),

/***/ 71771:
/***/ (function(module) {

module.exports = "/_next/static/images/EngageCustomers@2x-0e701c82eda9260bd2ddcf8ace4a42d0.webp";

/***/ })

}]);